export default __webpack_public_path__ + "static/media/infoBackground.47d3060d.svg";